/**
 * Filters for only alpha numeric characters, removing all other characters
 *
 * @param {string} value A string value to filter on
 */
export const filterAlphaNumeric = value => value.replace(/[^a-zA-Z0-9] /g, '')

/**
 * Given a string, normalizes it by removing all non-alphanumeric characters and
 * converting it to lowercase.  Useful for analytics purposes.
 *
 * @param {string} value a string to normalize
 */
export const normalizeString = value =>
  filterAlphaNumeric(value.trim().toLowerCase())
